import { useEffect, useState } from "react";
import { Button, Input, Form, Space, Tooltip } from "antd";
import { SelectOutlined } from "@ant-design/icons";


import DataTable from "../../DataTable";

interface StepProps {
  gotoStep: Function;
  current: number;
  onChange: Function;
  onSearch: Function;
  fetchPayments: Function;
  policies: any;
  claimType?: "Internal" | "External";
}

const FindPolicy: React.FC<StepProps> = ({ gotoStep, current, onChange, onSearch, fetchPayments, policies, claimType = "Internal" }) => {

  const form = Form.useFormInstance();

  const generateClaimNumber = () => {
    const ts = Date.now().toString().slice(-8);
    const rand = Math.floor(Math.random() * 1000).toString().padStart(3, "0");
    form?.setFieldsValue({ ClaimNumber: `CL${ts}${rand}` });
  };

  const [state, setState] = useState({
    loading: true,
    activeKey: "1",
    pagination: {
      pageSize: 10,
      position: ["bottomRight"],
      total: 0,
      current: 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const policyColumns = [
    {
      title: "",
      dataIndex: "Action",
      width: 100,
      render: (_: any, record: any) => (
        <Button
          size="small"
          type="primary"
          onClick={() => fetchPayments(record.Policy.PolicyNumber)}
        >
          {claimType === "External" ? "Select" : "Check"}
        </Button>
      ),
    },
    {
      title: "ID Number",
      dataIndex: "IdNumber",
    },
    {
      title: "Policy Number",
      dataIndex: ["Policy", "PolicyNumber"],
    },
    {
      title: "Name",
      dataIndex: "Name",
    },
    {
      title: "Surname",
      dataIndex: "Surname",
    },
    {
      title: "Inception Date",
      dataIndex: "InceptionDate",
    },
    {
      title: "Group",
      dataIndex: ["Group", "GroupName"],
    },
  ];

  const content = (
    <>
      <Space
        size={"large"}
        direction="vertical"
        style={{ width: "100%", textAlign: "center", margin: "0 0 16px 0" }}
      >
        <h2 style={{ margin: "16px 0", color: "#f04f05" }}>
          Search For The Policy You Would Like To Submit A Claim Against.
        </h2>
        <p style={{ margin: "16px 0" }}>
          You can search by Policy Number or ID Number.
        </p>
      </Space>

      {claimType === "External" && (
        <Form.Item
          label="Claim Number"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 8 }}
          required
        >
          <Space.Compact style={{ width: "100%" }}>
            <Form.Item
              name="ClaimNumber"
              noStyle
              rules={[{ required: true, message: "Claim Number is required" }]}
            >
              <Input size="large" placeholder="Enter or generate a claim number" />
            </Form.Item>
            <Button size="large" type="primary" onClick={generateClaimNumber}>
              Generate
            </Button>
          </Space.Compact>
        </Form.Item>
      )}

      <Form.Item
        wrapperCol={{ offset: 8, span: 8 }}
        name="PolicyNumber"
        rules={[
          {
            required: claimType !== "External",
            message: "Policy Number is required",
          },
        ]}
      >
        <Input
          size="large"
          placeholder={claimType === "External" ? "Policy Number (optional)" : "Policy Number"}
          onChange={(e) => onChange(e)}
        />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button block size="large" onClick={() => onSearch()}>
            Search
          </Button>
          {claimType === "External" && (
            <Button
              block
              size="large"
              type="primary"
              onClick={() => {
                const claimNo = form?.getFieldValue("ClaimNumber");
                if (!claimNo) {
                  form?.validateFields(["ClaimNumber"]);
                  return;
                }
                gotoStep(3);
              }}
            >
              Continue Without Policy
            </Button>
          )}
        </Space>
      </Form.Item>

      <Space
        size={"large"}
        direction="vertical"
        style={{
          width: "100%",
          textAlign: "center",
          margin: "16px 0 24px 0",
        }}
      >
        {policies.length > 0 && (
          <>
            <h4 style={{ padding: "16px 0" }}>
              Select The Policy You Want To Claim Against.
            </h4>
            <DataTable
              persistKey="claim-find-policy"
              dataSource={policies}
              columns={policyColumns}
              loading={""}
              pagination={state.pagination}
              onChange={""}
            />
          </>
        )}
      </Space>
    </>
  );

  return content;
};
export default FindPolicy;
